import { graphql } from 'react-relay';

export const archiveListFragment = graphql`
    fragment ArchiveList_component on ArchiveList {
        archiveTitle: title
        yearLabel
        livefilter {
            ...LiveFilter_liveFilter
        }
        detailfilter {
            ...DetailFilter_detailFilter
        }
        documents {
            ...ArchiveFileLink_archiveFileLink
            date
            doctypeheader
            header
            text
        }
        noresultstext
        filterbuttontext
        filterbuttontextexpanded
    }
`;
